export default __webpack_public_path__ + "static/media/Gold_Logo.399f37b0.png";